/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */



import {useEffect, useRef, useState} from "react";

export const useIsMounted = () => {
    const isMounted = useRef(true);
    
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);
    
    return () => isMounted.current;
}
